import { createServerFn } from '@tanstack/react-start';
import termsEn from '@/content/onboarding-terms/en.md?raw';
import termsEs from '@/content/onboarding-terms/es.md?raw';
import termsCa from '@/content/onboarding-terms/ca.md?raw';
import termsIt from '@/content/onboarding-terms/it.md?raw';
import * as z from 'zod';

const termsByLocale: Record<'en' | 'es' | 'ca' | 'it', string> = {
	en: termsEn,
	es: termsEs,
	ca: termsCa,
	it: termsIt,
};

export const getOnboardingTermsFn = createServerFn()
	.inputValidator(z.enum(['en', 'es', 'ca', 'it']))
	.handler(({ data: locale }) => termsByLocale[locale]);
